<template>
  <v-dialog
    v-model="response.status"
    persistent
    max-width="600px"
  >
    <v-card>
      <v-card-title>
        <!--<span class="text-h5">{{ response.message }}</span>-->
      </v-card-title>
      <v-card-text>
        <v-container>
          <template v-for="error in response.errors">
            <v-list-item v-for="err in error" :key="err">
              <v-list-item-content>
                <v-list-item-title>{{ err }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="response.status = false"
        >
          متوجه شدم
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'dialog-validation',
  props: {
    response: Object
  }
}
</script>

<style scoped>

</style>
